import React from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import { CheckValue } from '../../services/types/Misc';

interface Props {
  disabled?: boolean;
  className?: string;
  element: CheckValue;
  onChange: (id: string, value: boolean) => void;
}

const CheckBox: React.FC<Props> = ({ element, disabled, className, onChange }) => {
  const CheckedLabelClass = element.checked ? 'checked' : '';

  const change = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!disabled) {
      onChange(element.id, !element.checked);
    }
    e.preventDefault();
  };

  return (
    <div role="presentation" onClick={change} key={element.htmlId}>
      <label
        className={`${className || ''} checkbox-btn${disabled ? ' disabled' : ''}`}
        htmlFor={element.id}
      >
        <input
          className="checkbox-btn__checkbox"
          type="checkbox"
          id={element.htmlId || element.id}
          name={element.id}
          onChange={() => {}}
          checked={element.checked}
          disabled={disabled}
        />
        <span className="checkbox-btn__checkbox-custom">
          <CheckIcon />
        </span>
        <span className={`checkbox-btn__label ${CheckedLabelClass}`}>{element.text}</span>
      </label>
    </div>
  );
};

export default CheckBox;
